var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 10.8529C15.61 11.2171 15.1805 11.4345 14.7219 11.4439C14.2642 11.432 13.8362 11.215 13.5559 10.8529",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4441 10.8529C10.1653 11.2168 9.73634 11.4342 9.27808 11.4439C8.82013 11.432 8.39174 11.215 8.11108 10.8529",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 20.3331C15.7528 20.3312 19.0411 17.8201 20.0309 14.2001C21.1522 14.0779 22.0016 13.131 22.0016 12.0031C22.0016 10.8752 21.1522 9.92823 20.0309 9.80608C19.0437 6.18407 15.7541 3.67114 11.9999 3.67114C8.24579 3.67114 4.95621 6.18407 3.96894 9.80608C2.84766 9.92823 1.99829 10.8752 1.99829 12.0031C1.99829 13.131 2.84766 14.0779 3.96894 14.2001C4.95875 17.8201 8.24703 20.3312 11.9999 20.3331Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2221 15.0071C12.9489 16.1178 11.0512 16.1178 9.77808 15.0071",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 7.19099C11.2117 7.42643 11.6004 7.55415 11.9999 7.55599C13.0567 7.53203 13.9008 6.6685 13.9008 5.61149C13.9008 4.55448 13.0567 3.69096 11.9999 3.66699",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.2560daed0337b49cfe5c6081cd5c595c.svg";
export { ForwardRef as ReactComponent };